import { render } from "./PlayingTheGame.vue?vue&type=template&id=032ea2bc&scoped=true"
import script from "./PlayingTheGame.vue?vue&type=script&lang=js"
export * from "./PlayingTheGame.vue?vue&type=script&lang=js"

import "./PlayingTheGame.vue?vue&type=style&index=0&id=032ea2bc&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-032ea2bc"]])

export default __exports__